import React from 'react'
import { useParams } from 'react-router-dom'
import styles from './GeoHeader.module.scss'
import Content from '../../../components/Content'

import Layout from '../../../components/Layout'
import GeoProvider from '../../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from './../dataDisplayOptions'
import { startDate, endDate, displayDate } from './../dates'
import Header from './Header'
import Gender from '../../GenderAge'
import SeasonalPattern from '../../SeasonalPattern'
import SystemNotification from './../../Dashboard/SystemNotification'

const RSVGeoDashboard = () => {
  const { geo_parent, area, loc } = useParams()

  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
            >
              <SystemNotification/>
              <Header headerType={geo_parent} headerNumber={3} geo_id={loc} />

              <DashboardMap
                geo_type={area}
                geo_parent={geo_parent}
                zoomLocation={loc}
              />
              <Gender geo_type={area} geo_id={loc}  data_type="RSV"/>
              <SeasonalPattern geo_type={area} geo_id={loc}  data_type="RSV"/>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default RSVGeoDashboard
